import { render, staticRenderFns } from "./ReadData.vue?vue&type=template&id=56d3dfec&scoped=true&"
import script from "./ReadData.vue?vue&type=script&lang=js&"
export * from "./ReadData.vue?vue&type=script&lang=js&"
import style0 from "./ReadData.vue?vue&type=style&index=0&id=56d3dfec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d3dfec",
  null
  
)

export default component.exports